import React from "react";
import styles from "./MedicinesResult.module.scss";
import { MedicinesResultType } from "types";
//import { Location, SmallLogo, Emergency, Optica, Teeth, WomenEmergency } from "assets/icons";
import SvgGenerator from "components/svgGenerator/SvgGenerator";
import Text from "components/text/Text";
import strings from "assets/strings";
//import strings from "assets/strings";
//import { getAllClassNames,  } from "helpers";
//import { settings } from "assets/settings";

export const MedicinesResult = ({ hit }: { hit: MedicinesResultType }) => {

  const formattedAsteriskText = (text:string) => text.split('*').map((part, index) => (
    <React.Fragment key={index}>
      {part}
      {index < text.split('*').length - 1 && (
        <span style={{ color: 'var(--pink2)' }}>*</span>
      )}
    </React.Fragment>
  ));

  return (
    <div className={styles.hitMedicines}>
      <div className={styles.MedicinesDetails}>
        <div className={styles.section2}>
          <div className={styles.divText}>
            <Text
              className={styles.textMedicine}
              text={hit.name}
            />
            <Text
              className={styles.textDetail}
              text={`${strings.medicinesSearchResults.makat} ${hit.itemId}`}
            />
            {hit.isApprovalRequired && <div className={styles.divConfirmation}>
              <SvgGenerator name="TagRequired" className={styles.avatar} objectName="medicineSearchResults" fallBackIcon="TagRequired" />
              <Text className={styles.textConfirm} text={'דרוש אישור מקדים מגורם מוסמך'} />
            </div>
            }
          </div>
        </div>
        {/* <div className={styles.section}>
          <div className={styles.divText}>
            <Text
              className={styles.textTitle2}
              text={strings.medicinesSearchResults.yarpaPriceToCustomer}
            />
            <Text
              className={styles.textDetail}
              text={hit.yarpaPrice?.toLocaleString('en-US')}
            />
          </div>
        </div> */}
        <div className={styles.section}>
          <div className={styles.divText}>
            <Text
              className={styles.textTitle2}
              text={strings.medicinesSearchResults.basketPrice}
            />
            <Text
              className={styles.textDetail}
              text={hit.healthServiceBasket == '0' ? '-' : formattedAsteriskText(hit.healthServiceBasket)}
            />
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.divText}>
            <Text
              className={styles.textTitle2}
              text={strings.medicinesSearchResults.priceNotInBasket}
            />
            <Text
              className={styles.textDetail}
              text={hit.price == 0 ? '-' : hit.price}
            />
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.divText}>
            <Text
              className={styles.textTitle2}
              text={strings.medicinesSearchResults.leumitZhavav}
            />
            {hit.goldPrice && hit.goldPrice.every(price => price == '0') ? <Text className={styles.textDetail} text="-" />
              : hit.goldPrice && hit.goldPrice.filter(price => price !== '0').map(price => (<Text
                className={styles.textDetail}
                text={formattedAsteriskText(price.replace(/[\d.]+/, m => Number(m).toLocaleString('en-US')))}
              />
              ))}
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.divText}>
            <Text
              className={styles.textTitle2}
              text={strings.medicinesSearchResults.leumitSilver}
            />
            {hit.silverPrice && hit.silverPrice.every(price => price == '0') ? <Text className={styles.textDetail} text="-" />
              : hit.silverPrice && hit.silverPrice.filter(price => price !== '0').map(price => (<Text
                className={styles.textDetail}
                text={price == '0' ? '-' : price}
              />
              ))}
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.divText}>
            <Text
              className={styles.textTitle2}
              text={strings.medicinesSearchResults.yarpaPriceToCustomer}
            />
            <Text
              className={styles.textDetail}
              text={hit.yarpaPrice?.toLocaleString('en-US')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
